module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "racknow"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0007#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0008#intro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("JAMES R. AKERMAN")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0009#ch01"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Cartography and Decolonization")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("RAYMOND B. CRAIB")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0010#ch02"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Entangled Spaces: Mapping Multiple Identities in Eighteenth-Century New Spain")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("MAGALI CARRERA")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0011#ch03"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Cartography in the Production (and Silencing) of Colombian Independence History, 1807–1827")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("LINA DEL CASTILLO")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0012#ch04"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Democratizing the Map: The Geo-body and National Cartography in Guatemala, 1821–2010")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("JORDANA DYM")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0013#ch05"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Uncovering the Roles of African Surveyors and Draftsmen in Mapping the Gold Coast, 1874–1957")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("JAMIE MCGOWAN")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0014#ch06"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Multiscalar Nations: Cartography and Countercartography of the Egyptian Nation-State")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("KAREN CULCASI")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0015#ch07"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Art on the Line: Cartography and Creativity in a Divided World")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("SUMATHI RAMASWAMY")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0016#ch08"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Signs of the Times: Commercial Road Mapping and National Identity in South Africa")]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("THOMAS J. BASSETT")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "rcontrib"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0017#contrib"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0018#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d5f2ac2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Akerman-0006.vue
// module id = 69
// module chunks = 0